/**
 * defa.views.SearchResultCollectionView
 * A view for search results.
 * @version 1.2.0
 */
import EmptyView           from 'scripts/defa/basic/view-empty-view';
import SearchResultSnippet from 'scripts/defa/search-results/view-search-result-snippet';
import CollectionView      from 'scripts/poppet/collection-view';

const SearchResultCollectionView = CollectionView.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	childView: SearchResultSnippet,
	emptyView: EmptyView,
	
	emptyViewOptions: {
		context: 'noinstalled',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when a child view asks for the update screen.
	 * @param {view} childView  The view the event originated from.
	 * @void
	 */
	onChildviewOpen: function ( childView ) {
		let id   = childView.model.get( 'bid' ),
			type = childView.model.get( 'type' );
		
		this.trigger( 'searchResult:open', id, type );
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default SearchResultCollectionView;